





















import { Component, Vue, namespace } from 'nuxt-property-decorator'
import { IStyle } from '~/assets/interfaces/classes'
import { filterUrl } from '~/assets/filters/url'
import ComponentImage from '~/components/images/image.vue'
import ComponentTypographyH1 from '~/components/typography/h1.vue'
import { IMeta } from '~/assets/interfaces/meta'
import { NuxtAppOptions } from '~/node_modules/@nuxt/types'
import { INFO_API } from '~/assets/config/api-path'
import { IBreadcrumbsItem } from '~/assets/interfaces/navigation'
const pageStore = namespace('page')

@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  components: {
    ComponentTypographyH1,
    ComponentImage,
  },
  filters: {
    filterUrl,
  },
})
export default class pageHelpIndex extends Vue {
  private async asyncData({
    $axios,
  }: {
    $axios: NuxtAppOptions
    route: NuxtAppOptions
  }) {
    const response = await $axios.$get(INFO_API)

    return response
  }

  private $style!: IStyle
  private styleGrid!: IStyle
  private styleMobileGrid!: IStyle
  private get classWrapper() {
    return {
      [this.$style.wrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  private get classPageWrapper() {
    return {
      [this.styleGrid.container]: !this.$device.isMobileOrTablet,
      [this.styleMobileGrid.container]: this.$device.isMobileOrTablet,
      [this.$style.pageWrapper]: true,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
    }
  }

  @pageStore.Mutation('setMeta') private setMeta!: (
    meta: IMeta
  ) => Promise<void>

  @pageStore.Mutation('setBreadcrumbs') private setBreadcrumbs!: (
    breadcrumbs: IBreadcrumbsItem[]
  ) => Promise<void>

  private meta: IMeta | null = null
  private breadcrumbs: IBreadcrumbsItem[] = []
  private created(): void {
    if (this.meta) {
      this.setMeta(this.meta)
    }
    if (this.breadcrumbs) {
      this.setBreadcrumbs(this.breadcrumbs)
    }
  }
}
